import {
  Box,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import getSymbolFromCurrency from 'currency-symbol-map';
import React, { useEffect, useState } from 'react';
import AxiosConfig from '../../../../config/AxiosConfig';
import BrandIcon from '../../utils/common/BrandIcon';

const Refunds = ({ projectId }) => {
  const [refunds, setRefunds] = useState([]);
  useEffect(() => {
    AxiosConfig.create('get', `/projects/${projectId}/refunds`)
      .call()
      .exit((res) => {
        setRefunds(res?.data);
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center" sx={{ width: '10%' }}>
              Demande
            </TableCell>
            <TableCell align="center" sx={{ width: '10%' }}>
              Référence
            </TableCell>
            <TableCell align="center" sx={{ width: '15%' }}>
              Commande
            </TableCell>
            <TableCell align="center" sx={{ width: '10%' }}>
              Client
            </TableCell>
            <TableCell align="center" sx={{ width: '10%' }}>
              Montant TTC
            </TableCell>
            <TableCell align="center" sx={{ width: '10%' }}>
              Montant à rembourser
            </TableCell>
            <TableCell align="center" sx={{ width: '15%' }}>
              Justification
            </TableCell>
            <TableCell align="center" sx={{ width: '10%' }}>
              Auteur
            </TableCell>
            <TableCell align="center" sx={{ width: '10%' }}>
              Traitement
            </TableCell>
            <TableCell align="center" sx={{ width: '10%' }}>
              Crée le
            </TableCell>
            <TableCell align="center" sx={{ width: '10%' }}>
              Dernière mise à jour
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {refunds?.map((refund) => (
            <TableRow key={refund?.id}>
              <TableCell align="center">
                <Chip
                  label={refund?.type}
                  color={
                    refund?.type === 'Remboursement' ? 'tertiary' : 'primary'
                  }
                  size="small"
                  sx={{ width: '9rem', borderRadius: '5px', padding: 1 }}
                />
              </TableCell>
              <TableCell align="center">
                <Chip
                  label={refund?.ticket?.reference}
                  sx={{
                    width: '7rem',
                    borderRadius: '5px',
                    color: 'black',
                    backgroundColor: '#ececec',
                    fontSize: '0.9rem',
                  }}
                />
              </TableCell>
              <TableCell align="center">
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                  {refund?.order?.reference ? (
                    <>
                      <BrandIcon
                        brand={refund?.order?.contact?.store?.brand?.name}
                        type={
                          refund?.order?.contact?.store?.contactType?.codeBO
                        }
                        style={{ width: 'inherit', height: '24px' }}
                      />
                      {refund?.order?.reference}
                    </>
                  ) : (
                    'N/A'
                  )}
                </Box>
              </TableCell>
              <TableCell align="center">
                {refund?.firstName} {refund?.lastName}
              </TableCell>
              <TableCell align="center">
                {refund?.amountTotal}
                {getSymbolFromCurrency(
                  refund?.ticket?.contact?.store?.country?.currency?.code
                )}
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                {refund?.amountToRefund}
                {getSymbolFromCurrency(
                  refund?.ticket?.contact?.store?.country?.currency?.code
                )}
              </TableCell>
              <TableCell align="center">
                <Tooltip title={refund?.description} arrow>
                  <Chip
                    label={refund?.refundType?.name}
                    sx={{
                      width: '7rem',
                      borderRadius: '5px',
                      backgroundColor: '#e5ecf2',
                      color: 'black',
                      fontSize: '0.9rem',
                    }}
                  />
                </Tooltip>
              </TableCell>
              <TableCell align="center">
                {refund?.author?.firstName} {refund?.author?.lastName}
              </TableCell>
              <TableCell align="center">
                <Box
                  sx={{
                    width: '100%',
                    border: '1px solid #c4c4c4',
                    borderRadius: '5px',
                    padding: 1,
                  }}
                >
                  {refund?.status?.name}
                </Box>
              </TableCell>
              <TableCell align="center">
                {new Date(refund?.createdAt).toLocaleString('fr-FR', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                })}
              </TableCell>
              <TableCell align="center">
                {new Date(refund?.updatedAt).toLocaleString('fr-FR', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                })}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Refunds;
